import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";


export default function ViewAccount({
    showView,
    closeModal,
    refreshPage,
    currentAccount,
}) {
    const handleClose = () => {
        closeModal();
    };

    const [accountDetails, setAccountDetails] = useState({});

    useEffect(() => {
        if (currentAccount) {
            setAccountDetails(currentAccount);
        }
    }, [currentAccount]);

    const accountCard = accountDetails ? (
        <Card className="mb-3">
            <Card.Body>
                <Card.Text>
                    <strong>Account Name:</strong> {accountDetails.account_name}
                    <br />
                    <strong>Account Number:</strong> {accountDetails.account_number}
                    <br />
                    <strong>Bank:</strong> {accountDetails.bank}
                    <br />
                </Card.Text>
            </Card.Body>
        </Card>
    ) : (
        <p>No account details available.</p>
    );

    return (
        <div className="ViewAccount">
            <Modal show={showView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Account Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
                    {accountCard}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        style={{ backgroundColor: "#c4281b", border: "none" }}
                        onClick={refreshPage}
                    >
                        Refresh
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
